import React, { useEffect, useState } from 'react';
import { Autocomplete } from '@mantine/core';
import { SearchWrapper } from './styles';
import { ReactComponent as IconSearch } from './SearchIcon.svg';
import { ReactComponent as IconClose } from './close.svg'; // Assuming you have a close icon SVG

import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

interface FilterControlsProps {
  placeholder: string;
  data: string[]; // Data to be passed to Autocomplete
  searchKey?: string;
  isReset?: boolean;
}

export function SearchAutoComplete({
  placeholder,
  data,
  searchKey = 'name',
  isReset = false,
}: FilterControlsProps) {
  const { formatMessage } = useIntl();
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchParams, setSearchParams] = useSearchParams();

  useEffectOnce(() => {
    setSearchValue(searchParams.get(searchKey) ?? '');
  });

  useEffect(() => {
    if (isReset) {
      setSearchValue('');
    }
  }, [isReset]);

  function handleInput(input: string) {
    // Check if input is a number
    if (!isNaN(Number(input))) {
      // Convert number to string to handle leading zeros
      input = input.toString();
      // Remove leading zeros
      input = input.replace(/^0+/, '');
      input = input.replace(/\+/g, '');
    }
    return input;
  }

  const addToSearchParam = () => {
    searchParams.set(searchKey, searchValue);
    if (searchValue && searchValue.trim() !== '' && handleInput(searchValue)) {
      searchParams.set(searchKey, handleInput(searchValue));

      setSearchParams(searchParams);
    } else {
      handleClearSearch();
    }
  };

  const handleAutocompleteChange = (value: string) => {
    setSearchValue(value);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    searchParams.delete(searchKey);
    setSearchParams(searchParams);
  };

  const handleSearchEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      addToSearchParam();
    }
  };

  const handleSearchClick = () => {
    addToSearchParam();
  };

  return (
    <SearchWrapper className='wrapper'>
      <div className="search_wrappeer">
        <Autocomplete
          autoComplete=""
          data={[]}
          onKeyUp={(e) => handleSearchEnter(e)} // Use the data prop
          icon={<IconSearch onClick={handleSearchClick} className="active" />}
          rightSection={
            searchValue && <IconClose onClick={handleClearSearch} />
          }
          value={searchValue}
          onChange={handleAutocompleteChange}
          placeholder={formatMessage({
           
            id: placeholder,
          })}
        />
      </div>
    </SearchWrapper>
  );
}
